import React from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'

const CardTotalPessoas = ({ dados }) => {
  const total = Number(dados?.qtPessoas ?? 0)

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Participantes
        </Typography>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mt: 1 }}
        >
          <Typography fontSize={15} fontWeight="400">
            {total.toLocaleString()}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export default CardTotalPessoas
